
const config = {
    development: {
        // apiurl: 'http://contract_api.service.consul',
        // yun_domain: 'http://yun.service.consul',
        // domain: 'https://t.renshihr.cn',
        apiurl: 'http://contract_api.service.consul',
        yun_domain: 'http://yun.service.consul',
        domain: 'http://yun15.service.consul',
       
        env: 'dev'
    },
    local: {
        apiurl: 'http://contract_api.service.consul',
        yun_domain: 'http://yun.service.consul',
        domain: 'http://yun15.service.consul',
        wdomain: 'http://yunm.service.consul',

        shiquanshimei: 'http://ippt8.service.consul',
        env: 'local'
    },
    test: {
        apiurl: 'http://contractapi.renshihr.cn',
        yun_domain: 'https://tpa.renshihr.cn',
        domain: 'https://t.renshihr.cn',
        wdomain: 'http://renshihr.cn',

        wenhui: "https://wenhui.renshihr.cn",      //原文荟
        shiquanshimei: 'http://ippt8.renshihr.cn',
        env: 'test'
    },
    production: {
        apiurl: 'https://contractapi.renshihr.com',
        yun_domain: 'https://api.renshihr.com',
        domain: 'https://www.renshihr.com',
        wdomain: 'https://m.renshihr.com',

        wenhui: "http://ywh.renshihr.com",  //原文荟
        shiquanshimei: 'https://www.ippt8.com',
        env: 'production'
    }
}
console.log(process.env.VUE_APP_CONFIG)
module.exports = config[process.env.VUE_APP_CONFIG || 'development']